import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { ButtonSecondarySquareSmall } from "../../generic/common/ButtonSecondarySquareSmall";
import { Icon } from "../../generic/icon/Icon";
export var ThemedEventIcon = function (_a) {
    var onClick = _a.onClick, icon = _a.icon;
    return (React.createElement("div", { className: "quest-item-description__container-event-icon-container", onClick: onClick },
        React.createElement(ButtonSecondarySquareSmall, null),
        React.createElement("div", { className: "quest-item-description__container-event-icon-content" },
            React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: icon }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/ThemedEventIcon.tsx
// module id = 2662
// module chunks = 3